

<mat-dialog-content class="mat-typography">
  <h2 mat-dialog-title>Add New Rule</h2>
  <app-rule-editor (ruleSavedEvent)="ruleSaved()"
    [editorID]="this.editorId"
    [isModal]="true"                                                 
    [criteriaId]="this.criteriaId" 
    [ruleGroupId]="this.ruleGroupId" 
    [componentId]="this.componentId"
    [ruleId]="-1" >
  </app-rule-editor>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>